<div class="sticky-bar int-sticky-bar" [class.scrolled]="isScrolled" [class.mobile-open]="floatingOpen" [class.mobile-collapsed]="isMobile && !floatingOpen">
  <div *ngIf="isMobile" class="floating-toggle" (click)="toggleFloating($event)">
    <i class="fa" [ngClass]="{'fa-angle-left': !floatingOpen, 'fa-times': floatingOpen}"></i>
  </div>
  <ul>
    <li [class.shrink]="isScrolled">
      <a href="https://api.whatsapp.com/send/?phone=917774008603 &text=Hi, I need assistance for Admission at your Institute for Academic Year 2027-26"
        target="_blank" rel="noopener noreferrer">
       <div class="icon pe-2"><i class="fab fa-whatsapp"></i></div>
        <div class="whatsapp">Whatsapp Chat</div>

      </a>
    </li>
    <li [class.shrink]="isScrolled">
      <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" rel="noopener noreferrer">
        <div class="icon pe-2"><i class="fas fa-edit"></i></div>
        <div class="st-label">Apply Now</div>
      </a>
    </li>
    <li class="conference-tab" [class.shrink]="isScrolled">
      <a href="https://incowoco.com/" target="_blank" rel="noopener noreferrer">
        <div class="icon pe-2"><i class="fas fa-edit"></i></div>
        <div class="st-label">Incowoco</div>
      </a>
    </li>
     <!-- <li class="conference-tab" [class.shrink]="isScrolled" >
      <a href="https://currentopenings.raisoni.net" target="_blank" rel="noopener noreferrer">
        <div class="icon pe-2"><i class="fas fa-edit"></i></div>
        <div class="st-label">Current Opening</div>
      </a>
    </li> -->
    <!-- <li class="conference-tab">
      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcempune/pdf/circular-fra-fee.pdf" target="_blank" rel="noopener noreferrer">
        <div class="icon pe-2"><i class="fas fa-edit"></i></div>
        <div class="st-label">FRA-Fee </div>
      </a>
    </li> -->
    <li class="conference-tab" [class.shrink]="isScrolled">
      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcempune/pdf/fra-circular-2026-27.pdf" target="_blank" rel="noopener noreferrer">
        <div class="icon pe-2"><i class="fas fa-edit"></i></div>
        <div class="st-label">FRA-Fee </div>
      </a>
    </li>
    <!-- <li class="conference-tab "  [class.shrink]="isScrolled">
      <a href="javascript:void(0)" (click)="openNiaChat($event)">
        <div class="icon pe-2"><i class="fas fa-robot"></i></div>
        <div class="st-label">Nia Chat</div>
      </a>
    </li> -->
    <li class="conference-tab "  [class.shrink]="isScrolled">
      <a href="https://braincon.brainallianz.org/index.html" target="_blank" rel="noopener noreferrer">
        <div class="icon pe-2"><i class="fas fa-edit"></i></div>
        <div class="st-label">BRAINCON-26 </div>
      </a>
    </li>
  </ul>
</div>


<div class="trigger-tab">
  <div class="trigger_popup">
    <button type="button" class="" id="myBtn">Enquire Now</button>
  </div>
</div>

<div class="modal fade" id="mock-cet" tabindex="-1" aria-labelledby="mockCetLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="mockCetLabel">Mock CET Details</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <img loading="lazy" decoding="async" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcempune/images/mock-cet.avif" alt="mock-cet"
          title="mock-cet" class="img-fluid mb-2" />
        <h6>The examination link:</h6>
        <a href="https://mock.testplanners.com/login.php" target="_blank" rel="noopener noreferrer">https://mock.testplanners.com/login.php</a>
        <ul class="list-circle list-count">
          <li>Step1: Click on Register NEW</li>
          <li>Step2: Enter your details</li>
          <li>Step3: Click START (exam will start)</li>
        </ul>
        <h5><strong>The result will be shared in 48 Hours of the exam.</strong></h5>
        <p>In case of any query please contact us on</p>
        <h5><strong>9922411126, 9689002418</strong></h5>
      </div>

    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="video-counselling" tabindex="-1" aria-labelledby="videoCounsellingLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="videoCounsellingLabel">Video Counselling</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div>
          <img loading="lazy" decoding="async" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcempune/images/banner/video-counselling.avif"
            alt="video-counselling" title="video-counselling" class="img-fluid" />
          <h4> Admission - 2026 Live Video Counselling (One to One Interaction)</h4>
          <p>
            Interact with expert Admission Counsellors through live video counselling for career guidance to discover
            one's best-suited programme / stream from 10 am to 6 pm on all working days except for Sundays
          </p>
        </div>
      </div>
      <div class="modal-footer">
        <a href="https://ghraisoni.webex.com/webappng/sites/ghraisoni/dashboard?siteurl=ghraisoni&viewSwitch=c2m"
          target="_blank" rel="noopener noreferrer" class="btn button--effect-1">
          <span> Read More<span class="visually-hidden"> about Live Video Counselling</span></span>
        </a>
      </div>
    </div>
  </div>
</div>


<!-- The Modal -->
<div id="myModal" class="modal" data-backdrop="static" data-keyboard="false">
  <!-- Modal content -->
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="head_text"> Admission enquiry</div>
      <span class="close" onclick="document.getElementById('myModal').style.display='none'"
        style="top: 2px;right: 2px;">&times;</span>
      <div class="modal-body p-0">
        <div class="widget-box">
          <div class="npf_wgts" data-height="620px" data-w="0b10b6718096f8ec2f7916d74a9824c8">
            <iframe frameborder="0" width="100%" height="620px" scrolling="no"
              sandbox="allow-top-navigation allow-scripts allow-same-origin"
              src="https://widgets.nopaperforms.com/register?&amp;r=&amp;q=&amp;w=0b10b6718096f8ec2f7916d74a9824c8&amp;m=&amp;cu=https://www.raisoni.net/media/photo-gallery/"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="npf_chatbots" data-w="9d4303fa6f5d402cb4dcd0e0b7c88f29" style="display:none;"></div>

